import { Message, MessageBox } from 'element-ui'
import store from '../store'

export default function handleError (res) {
  if (res.status === '10006') {
    MessageBox.confirm('登陆超时，请重新登录', '确定登出', {
      confirmButtonText: '重新登录',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    }, cancel => {
      console.log(cancel)
    })
  } else if (res.status === '70037') {
    MessageBox.confirm('权限过期，请重新登录', '确定登出', {
      confirmButtonText: '重新登录',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    }, cancel => {
      console.log(cancel)
    })
  } else if (res.status === '70100') {
    MessageBox.confirm('账号重复登录', {
      confirmButtonText: '重新登录',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    }, cancel => {
      console.log(cancel)
    })
  } else if (res.status === '70101') {
    MessageBox.confirm('您的权限已经更改， 请重新登录', {
      confirmButtonText: '重新登录',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      store.dispatch('FedLogOut').then(() => {
        location.reload()// 为了重新实例化vue-router对象 避免bug
      })
    }, cancel => {
      console.log(cancel)
    })
  } else {
    Message({
      message: res.msg,
      type: 'error',
      duration: 5 * 1000
    })
  }
  return Promise.reject(res)
}



// WEBPACK FOOTER //
// ./src/utils/businessErrorHandler.js